import messages from './messages_en';
import labels from './labelsEn';

export default {
  hello: 'HELLO!!',
  messages,
  labels
};
